export default __webpack_public_path__ + "static/derecho-mobile-2565d763362212daed3dd337c1072fd4.svg";